import type { BffApiClient } from "@/app/api-client"
import { getNftSearchQueryParams } from "@/app/nft/search/result/utils"
import type { UnionAddress } from "@anaconda/core/blockchain/address"
import type { Blockchain } from "@anaconda/core/blockchain/types"
import type { CollectionId } from "@anaconda/core/nft-collection/types"
import { DEFAULT_SORT } from "@anaconda/core/nft/search/constants"
import { StatusFilterOption } from "@anaconda/core/nft/search/types"

const buildUserCollectionItemsFilters = ({
  collectionId,
  owner,
  blockchains,
}: {
  collectionId: CollectionId
  owner?: UnionAddress
  blockchains: Blockchain[]
}) => {
  return {
    collection: collectionId,
    ...(owner ? { owner } : {}),
    blockchains,
    status: StatusFilterOption.ALL,
  }
}

export const getAllUserCollectionItemsQueryParams = (
  apiClient: BffApiClient,
  { collectionId, owner }: { collectionId: CollectionId; owner?: UnionAddress },
  blockchains: Blockchain[],
) => {
  return getNftSearchQueryParams(apiClient, {
    filters: buildUserCollectionItemsFilters({
      collectionId,
      owner,
      blockchains,
    }),
    sort: DEFAULT_SORT,
  })
}

export const getUserCollectionItemsCountQueryParams = (
  apiClient: BffApiClient,
  { collectionId, owner }: { collectionId: CollectionId; owner?: UnionAddress },
  blockchains: Blockchain[],
) => {
  const input = {
    filters: buildUserCollectionItemsFilters({
      collectionId,
      owner,
      blockchains,
    }),
    sort: DEFAULT_SORT,
    pageSize: 1,
  }

  return {
    queryKey: ["collections", "userItemsCount", input],
    queryFn: async () => {
      const response = await apiClient.api.nfts.search.$post({ json: input })

      if (!response.ok) {
        const errorData = await response.json()
        console.error(
          "[User Collection Items Count Error]",
          response.status,
          errorData,
          "\nRequest params:",
          input,
        )
        throw errorData
      }

      const data = await response.json()

      return data.totalNftsCount
    },
  }
}
